import { freeze } from '@reduxjs/toolkit';
import {
  ISignificanceBuilderBreakdownCriteria,
  ISignificanceBuilderCriteria,
  ISignificanceBuilderExperimentCriteria,
  ISignificanceBuilderFields,
  ISignificanceBuilderFunnelMetric,
  ISignificanceBuilderMeasureMetric,
  ISignificanceBuilderMetric,
  ISignificanceBuilderQueryMetric,
  ISignificanceBuilderRetentionMetric,
  ISignificanceBuilderSegmentCriteria,
} from './types';
import {
  MetricTypeKey,
  SignificanceModeKey,
} from '../../../../utils/apollo/graphqlSchema';

export const defaultSignificanceBuilderState =
  freeze<ISignificanceBuilderFields>(
    {
      confidenceLevel: 95,
      significanceLevel: 0.05,
      metric: null,
      criteria: null,
      errors: {},
    },
    true,
  );

export const defaultBreakdownCriteria =
  freeze<ISignificanceBuilderBreakdownCriteria>(
    {
      modeKey: SignificanceModeKey.Breakdown,
      field: null,
      controlGroup: null,
      variants: [null],
    },
    true,
  );
export const defaultSegmentCriteria =
  freeze<ISignificanceBuilderSegmentCriteria>(
    {
      modeKey: SignificanceModeKey.Segment,
      controlGroup: null,
      variants: [null],
    },
    true,
  );
export const defaultExperimentCriteria =
  freeze<ISignificanceBuilderExperimentCriteria>(
    {
      modeKey: SignificanceModeKey.Experiment,
      experimentId: null,
      controlGroup: null,
      variants: [null],
    },
    true,
  );
export const defaultCriteriaBySignificanceMode: Record<
  SignificanceModeKey,
  ISignificanceBuilderCriteria
> = {
  [SignificanceModeKey.Breakdown]: defaultBreakdownCriteria,
  [SignificanceModeKey.Segment]: defaultSegmentCriteria,
  [SignificanceModeKey.Experiment]: defaultExperimentCriteria,
};

export const defaultMeasureMetric = freeze<ISignificanceBuilderMeasureMetric>(
  {
    type: MetricTypeKey.Measure,
    measure: null,
  },
  true,
);
export const defaultFunnelMetric = freeze<ISignificanceBuilderFunnelMetric>(
  {
    type: MetricTypeKey.Funnel,
    analysisId: null,
    steps: [],
    convertedOnStep: 0,
    aliasReplacements: [],
    mode: null,
    modeSlices: [],
    ttcMetric: null,
  },
  true,
);
export const defaultQueryMetric = freeze<ISignificanceBuilderQueryMetric>(
  {
    type: MetricTypeKey.Query,
    analysisId: null,
    measureId: null,
    aliasReplacements: [],
  },
  true,
);
export const defaultRetentionMetric =
  freeze<ISignificanceBuilderRetentionMetric>(
    {
      type: MetricTypeKey.Retention,
      analysisId: null,
    },
    true,
  );
export const defaultMetricBySignificanceMetricType: Record<
  MetricTypeKey,
  ISignificanceBuilderMetric
> = {
  [MetricTypeKey.Measure]: defaultMeasureMetric,
  [MetricTypeKey.Funnel]: defaultFunnelMetric,
  [MetricTypeKey.Query]: defaultQueryMetric,
  [MetricTypeKey.Retention]: defaultRetentionMetric,
};
